import { memo } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCentralizedExport } from 'contexts/CentralizedExportProvider';
import { InventoryDownloadService, SalesDownloadService } from 'modules/export/services';
import { ReceiptLong } from '@mui/icons-material';

const OrderExportTracking = ({ orderId, path }: { orderId: string; path: string }) => {
  const { t } = useTranslation('order');
  const { triggerExport } = useCentralizedExport();

  const handleExportTracking = () => {
    triggerExport({
      title: 'common:exportDialog.title',
      confirmation: 'common:exportDialog.confirmation',
      total: 1,
      exportHook: async () => {
        const payload = {
          total: 1,
          search: '',
        };
        return await SalesDownloadService._getExportPath(payload, path || `/orders/export/${orderId}/tracking-page`);
      },
      downloadFn: InventoryDownloadService._downloadFileToPDF,
      storageKey: '_export_hide_single_order_tracking',
    });
  };

  return (
    <MenuItem onClick={handleExportTracking}>
      <ListItemIcon>
        <ReceiptLong fontSize='small' />
      </ListItemIcon>
      <ListItemText>{t('header.actions.export.exportTracking')}</ListItemText>
    </MenuItem>
  );
};

export default memo(OrderExportTracking);
